module.exports = __webpack_public_path__ + "img/reply-avatar.770cec64.png";